// extracted by mini-css-extract-plugin
export default {"fotoSobreMim":"SobreMim_fotoSobreMim__RVlMJ","subtitulo":"SobreMim_subtitulo__faWMa","paragrafo":"SobreMim_paragrafo__tHGbJ"};